import { createContext } from 'react';

import { NavigationStateContext } from './interfaces';

export const DrawerContext = createContext<NavigationStateContext>({} as NavigationStateContext);
